var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { gql } from '@apollo/client';
import { areDatesEqual } from '@amzn/atoz-shiftapp-utilities';
import { SwapFlowModalContentTypes } from '../SwapFlowModalFeature/SwapFlowModalTypes';
import { getSwapToDates } from '@amzn/atoz-shiftapp-utilities';
import { SwapRequestList } from '.';
export var getCurrentSelectedDays = function (date, selectedDates) {
    var isDayPreviouslySelected = (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.find(function (current) { return current.isValid && areDatesEqual(current, date); }))
        ? true
        : false;
    var updatedSelectedDays = isDayPreviouslySelected
        ? selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.filter(function (previouslySelectedDate) {
            return !areDatesEqual(date, previouslySelectedDate);
        })
        : __spreadArray(__spreadArray([], selectedDates, true), [date], false);
    return updatedSelectedDays;
};
export var SwapRequestListFeature = function (_a) {
    var originalShift = _a.originalShift, siteSwapConfiguration = _a.siteSwapConfiguration, close = _a.close, currentSelectedDays = _a.currentSelectedDays, setCurrentSelectedDays = _a.setCurrentSelectedDays, setModalContent = _a.setModalContent, allScheduleDaysForDay = _a.allScheduleDaysForDay;
    var _b = React.useState(false), validationError = _b[0], setValidationError = _b[1];
    React.useEffect(function () {
        if (!!currentSelectedDays.length) {
            setValidationError(false);
        }
    }, [currentSelectedDays]);
    var handleOpenModal = function () {
        if (!!currentSelectedDays.length) {
            setModalContent(SwapFlowModalContentTypes.terms);
        }
        else {
            setValidationError(true);
        }
    };
    var handleCheckboxClick = function (checkedDay) {
        if (checkedDay.isValid) {
            var selectedSwapRequestDays = getCurrentSelectedDays(checkedDay, currentSelectedDays);
            setCurrentSelectedDays(selectedSwapRequestDays);
        }
    };
    var swapToDates = getSwapToDates(originalShift);
    return (React.createElement(SwapRequestList, { swapToDates: swapToDates, swapFromDate: originalShift.date, allScheduleDaysForDay: allScheduleDaysForDay, toggleAction: handleCheckboxClick, handleClick: handleOpenModal, closeAction: close, selectedDates: currentSelectedDays, validationError: validationError, siteId: siteSwapConfiguration.siteId }));
};
SwapRequestListFeature.fragments = {
    siteSwapConfiguration: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment SwapRequestListFeature_SiteSwapConfiguration on SiteSwapConfiguration {\n            siteId\n        }\n    "], ["\n        fragment SwapRequestListFeature_SiteSwapConfiguration on SiteSwapConfiguration {\n            siteId\n        }\n    "]))),
    swapScheduleDay: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        fragment SwapRequestListFeature_SwapScheduleDay on SwapScheduleDay {\n            date\n            swappableDays {\n                date\n                swapOpportunities {\n                    id\n                    timeRange {\n                        start\n                        end\n                    }\n                }\n            }\n            timeRange {\n                start\n                end\n            }\n        }\n    "], ["\n        fragment SwapRequestListFeature_SwapScheduleDay on SwapScheduleDay {\n            date\n            swappableDays {\n                date\n                swapOpportunities {\n                    id\n                    timeRange {\n                        start\n                        end\n                    }\n                }\n            }\n            timeRange {\n                start\n                end\n            }\n        }\n    "])))
};
var templateObject_1, templateObject_2;
